export default {
  pt: {
    pageTitle: "Qual o modelo da sua {brand}?",
    description: "Encontre a sua bike entre os modelos elegíveis ao seguro.",
    searchLabel: "Pesquise o modelo ou tipo",
    notFoundButton: "Não encontro meu modelo",
    reportInfoAttentionTitle: "Antes de continuar, leia com atenção",
    reportInfoTitle: "O valor a seguir é uma simulação",
    reportInfoSimulation:
      "Como seu modelo não está no catálogo, simulamos os planos com base no valor que você informou.",
    reportInfoNewPrice:
      'O seguro considera o "valor de novo": o preço de uma bike nova igual à sua, não de uma usada. Por isso, o valor final pode mudar.',
    reportInfoReview:
      "Um consultor vai entrar em contato para confirmar o modelo, o valor e os detalhes do seu seguro.",
    reportInfoReviewOutOfHours:
      "Recebemos as informações da sua bike e um consultor vai entrar em contato para confirmar os detalhes do seu seguro.<br><br><u>Nosso horário de atendimento é de {weekdays}, das {start} às {end}.</u>",
    reportInfoConsentLabel: "Entendi e quero ver a simulação com o valor que informei.",
    reportInfoContinueButton: "Entendi, continuar",
  },

  en: {
    pageTitle: "What is your {brand} model?",
    description: "Find your bike among the models eligible for insurance.",
    searchLabel: "Search for model or type",
    notFoundButton: "I can't find my model",
    reportInfoAttentionTitle: "Before continuing, please read carefully",
    reportInfoTitle: "The value below is a simulation",
    reportInfoSimulation:
      "Since your model isn't in our catalog, we simulated the plans based on the value you provided.",
    reportInfoNewPrice:
      'Your insurance is based on the "new bike value": the price of a brand-new bike of the same model, not a used one. Because of that, the final value may change.',
    reportInfoReview:
      "A consultant will reach out to confirm the model, value, and details of your insurance.",
    reportInfoReviewOutOfHours:
      "We received your bike's details and a consultant will reach out to confirm your insurance details.<br><br><u>Our support hours are {weekdays}, from {start} to {end}.</u>",
    reportInfoConsentLabel:
      "I understand and want to see the simulation with the value I provided.",
    reportInfoContinueButton: "Got it, continue",
  },
};
